var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('iframe', {
    staticStyle: {
      "margin-left": "-10px",
      "margin-right": "-20px"
    },
    attrs: {
      "src": "https://acme-notification.azurewebsites.net",
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._v(" 看不到頁面時才會顯示這行文字 iframe: Acmepointes Notification 使用指南 ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };